import React, { memo, useState } from 'react';
import { Select } from '../index';
import { EditIcon } from '../../../pages/Project/Funds/icons';
import { FiCheck, FiX } from 'react-icons/fi';
import * as Styled from './style';

interface SelectWithPencilProps {
  id: string;
  viewOnly?: boolean;
  selectOptions: any[];
  isLoading?: boolean;
  onApproveButtonClick: (selectedValue: any) => void;
  selectEditingState: { id: string; state: string };
  setSelectEditingState: (state: { id: string; state: string }) => void;
  text?: string;
}

interface Option {
  id: string;
  name: string;
}

export const SELECT_PENCIL_STATES = {
  DEFAULT: 'default',
  SELECTING: 'selecting'
};

export const SelectWithPencil = memo(
  ({
    id,
    viewOnly = false,
    selectOptions,
    isLoading,
    onApproveButtonClick,
    selectEditingState,
    setSelectEditingState,
    text = ''
  }: SelectWithPencilProps) => {
    const [localSelectValue, setLocalSelectValue] = useState<Option | null>(null);
    const [localText, setText] = useState(text);

    const setEditingStateToDefault = () => {
      setSelectEditingState({
        id,
        state: SELECT_PENCIL_STATES.DEFAULT
      });
    };

    const handleApproveButtonClick = () => {
      if (!localSelectValue?.id) {
        setEditingStateToDefault();
        return;
      }
      onApproveButtonClick(localSelectValue);
      setText(localSelectValue.name);
      setEditingStateToDefault();
    };

    const handleLocalSelectChange = (selectedValue: Option | null) => {
      setLocalSelectValue(selectedValue);
    };

    const handleEditingButtonClick = () => {
      setSelectEditingState({ id, state: SELECT_PENCIL_STATES.SELECTING });
    };

    const handleRejectButtonClick = () => {
      setEditingStateToDefault();
    };

    const renderEditingState = () => {
      if (
        selectEditingState.id === id &&
        selectEditingState.state === SELECT_PENCIL_STATES.SELECTING
      ) {
        return (
          <Styled.SelectingStateWrapper>
            <Select
              value={localSelectValue}
              isSearchable
              options={selectOptions}
              getOptionValue={opt => opt?.id}
              getOptionLabel={opt => opt?.name}
              onChange={handleLocalSelectChange}
              isLoading={isLoading}
            />
            <Styled.EditIconButton onClick={handleApproveButtonClick}>
              <FiCheck className="approve" size={18} color="#CED4DA" />
            </Styled.EditIconButton>
            <Styled.EditIconButton onClick={handleRejectButtonClick}>
              <FiX className="reject" size={18} color="#CED4DA" />
            </Styled.EditIconButton>
          </Styled.SelectingStateWrapper>
        );
      }

      return (
        <Styled.DefaultStateWrapper>
          <span>{localText}</span>
          <Styled.EditIconButton onClick={handleEditingButtonClick}>
            <EditIcon size={18} color="#CED4DA" />
          </Styled.EditIconButton>
        </Styled.DefaultStateWrapper>
      );
    };

    if (viewOnly) {
      return <Styled.Wrapper>{localText}</Styled.Wrapper>;
    }

    return <Styled.Wrapper>{renderEditingState()}</Styled.Wrapper>;
  }
);

SelectWithPencil.displayName = 'SelectWithPencil';
